import { ratingFromKnots } from "@/lib/api";
import { Wind } from "lucide-react";

const DAYS = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
const colorBar = {
  sky: "bg-sky-400",
  cyan: "bg-cyan-400",
  emerald: "bg-emerald-500",
  orange: "bg-orange-500",
  red: "bg-red-500",
  slate: "bg-slate-300",
};

export function Forecast({ daily = [] }) {
  const maxWind = Math.max(...daily.map((d) => d.gust_max || 0), 30);
  return (
    <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-5" data-testid="forecast">
      <h3 className="font-head text-xl font-semibold text-slate-900 mb-4">Prossimi 7 giorni</h3>
      <div className="space-y-3">
        {daily.map((d, i) => {
          const dt = new Date(d.date);
          const rating = ratingFromKnots(d.wind_max);
          const pct = Math.min(100, ((d.gust_max || 0) / maxWind) * 100);
          return (
            <div key={d.date} className="flex items-center gap-3" data-testid={`forecast-day-${i}`}>
              <div className="w-10 shrink-0">
                <div className="font-head font-bold text-slate-900 text-sm">
                  {i === 0 ? "Oggi" : DAYS[dt.getDay()]}
                </div>
                <div className="text-[10px] text-slate-400">{dt.getDate()}/{dt.getMonth() + 1}</div>
              </div>
              <div className="flex-1 h-6 bg-slate-100 rounded-full overflow-hidden relative">
                <div
                  className={`h-full ${colorBar[rating.color]} rounded-full transition-all duration-500`}
                  style={{ width: `${pct}%` }}
                />
              </div>
              <div className="w-24 shrink-0 text-right flex items-center justify-end gap-1">
                <Wind className="h-3 w-3 text-slate-400" />
                <span className="font-head font-bold text-slate-900 text-sm">
                  {Math.round(d.wind_max)}
                </span>
                <span className="text-[10px] text-slate-400">/{Math.round(d.gust_max)}kn</span>
              </div>
              <div className="w-9 shrink-0 text-right text-xs font-bold text-sky-600">
                {d.wind_compass}
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-[11px] text-slate-400 mt-4">
        Barra = raffica max · numero = vento medio / raffica · colore = qualità per il surf
      </p>
    </div>
  );
}
